module.exports = __webpack_public_path__ + "img/sint-maarten.a2b141e5.svg";